<form [formGroup]="surveyForm">
    <ng-container [ngSwitch]="currentQuestion">
        <div *ngSwitchCase="1">
            <div class="title">{{ 'aumico_survey_popup_question_one' | i18next }}</div>
            <div class="checkbox-container">
                <span
                    class="custom-checkbox"
                    hamCheckbox
                    [single]="true"
                    [checked]="
                        surveyForm.controls['question1'].value === surveyQuestionResponseOptions.VERY_DISAPPOINTED
                    "
                    (change)="onResponseChanged($event, surveyQuestionResponseOptions.VERY_DISAPPOINTED)"
                >
                    {{ 'aumico_survey_popup_question_one_response_very_disappointed' | i18next }}
                </span>
                <span
                    class="custom-checkbox"
                    hamCheckbox
                    [single]="true"
                    [checked]="surveyForm.controls['question1'].value === surveyQuestionResponseOptions.DISAPPOINTED"
                    (change)="onResponseChanged($event, surveyQuestionResponseOptions.DISAPPOINTED)"
                >
                    {{ 'aumico_survey_popup_question_one_response_somewhat_disappointed' | i18next }}
                </span>
                <span
                    class="custom-checkbox"
                    hamCheckbox
                    [single]="true"
                    [checked]="
                        surveyForm.controls['question1'].value === surveyQuestionResponseOptions.NOT_DISAPPOINTED
                    "
                    (change)="onResponseChanged($event, surveyQuestionResponseOptions.NOT_DISAPPOINTED)"
                >
                    {{ 'aumico_survey_popup_question_one_response_not_disappointed' | i18next }}
                </span>
            </div>
            <div class="divider"></div>
            <div class="footer">
                <div class="question-number">{{ currentQuestion }} {{ 'aumico_survey_popup_of' | i18next }} 4</div>
                <div>
                    <ham-button
                        class="next-button"
                        type="submit"
                        size="xs"
                        [disabled]="!surveyForm.controls['question1'].valid"
                        (buttonClick)="saveResponse(1, response)"
                    >
                        {{ 'aumico_survey_popup_next_button' | i18next }}
                    </ham-button>
                </div>
            </div>
        </div>

        <div *ngSwitchCase="2">
            <div class="title">{{ 'aumico_survey_popup_question_two' | i18next }}</div>
            <textarea
                #question2Response
                formControlName="question2"
                placeholder="{{ 'aumico_survey_popup_placeholder' | i18next }}"
            ></textarea>
            <div class="divider"></div>
            <div class="footer">
                <div class="question-number">{{ currentQuestion }} {{ 'aumico_survey_popup_of' | i18next }} 4</div>
                <div>
                    <ham-button type="submit" outline="true" size="xs" (buttonClick)="goBack()">
                        {{ 'aumico_survey_popup_go_back_button' | i18next }}
                    </ham-button>
                    <ham-button
                        class="next-button"
                        type="submit"
                        size="xs"
                        [disabled]="!surveyForm.controls['question2'].valid"
                        (buttonClick)="saveResponse(2, question2Response.value)"
                    >
                        {{ 'aumico_survey_popup_next_button' | i18next }}
                    </ham-button>
                </div>
            </div>
        </div>

        <div *ngSwitchCase="3">
            <div class="title">{{ 'aumico_survey_popup_question_three' | i18next }}</div>
            <textarea
                #question3Response
                formControlName="question3"
                placeholder="{{ 'aumico_survey_popup_placeholder' | i18next }}"
            ></textarea>
            <div class="divider"></div>
            <div class="footer">
                <div class="question-number">{{ currentQuestion }} {{ 'aumico_survey_popup_of' | i18next }} 4</div>
                <div>
                    <ham-button type="submit" outline="true" size="xs" (buttonClick)="goBack()">
                        {{ 'aumico_survey_popup_go_back_button' | i18next }}
                    </ham-button>
                    <ham-button
                        class="next-button"
                        type="submit"
                        size="xs"
                        [disabled]="!surveyForm.controls['question3'].valid"
                        (buttonClick)="saveResponse(3, question3Response.value)"
                    >
                        {{ 'aumico_survey_popup_next_button' | i18next }}
                    </ham-button>
                </div>
            </div>
        </div>

        <div *ngSwitchCase="4">
            <div class="title">{{ 'aumico_survey_popup_question_four' | i18next }}</div>
            <textarea
                #question4Response
                formControlName="question4"
                placeholder="{{ 'aumico_survey_popup_placeholder' | i18next }}"
            ></textarea>
            <div class="divider"></div>
            <div class="footer">
                <div class="question-number">{{ currentQuestion }} {{ 'aumico_survey_popup_of' | i18next }} 4</div>
                <div>
                    <ham-button type="submit" outline="true" size="xs" (buttonClick)="goBack()">
                        {{ 'aumico_survey_popup_go_back_button' | i18next }}
                    </ham-button>
                    <ham-button
                        class="next-button"
                        type="submit"
                        size="xs"
                        [disabled]="!surveyForm.controls['question4'].valid"
                        (buttonClick)="saveResponse(4, question4Response.value)"
                    >
                        {{ 'aumico_survey_popup_submit_button' | i18next }}
                    </ham-button>
                </div>
            </div>
        </div>

        <div *ngSwitchCase="5" class="thank-you">
            <div class="check-icon-container">
                <span
                    hamIconShapes
                    class="check-icon"
                    icon="'assets/hamIcons/check-outline.svg'"
                    [variant]="'dark-green'"
                    [size]="'xl'"
                ></span>
            </div>
            <div class="title">{{ 'aumico_survey_popup_thank_you' | i18next }}</div>
            <p class="thank-you-message">{{ 'aumico_survey_popup_we_value_your_feedback' | i18next }}</p>
            <div class="divider divider-thank-you"></div>
            <div class="footer-close-button">
                <ham-button type="submit" outline="true" size="xs" (buttonClick)="onComplete()">
                    {{ 'aumico_survey_popup_close_button' | i18next }}
                </ham-button>
            </div>
        </div>
    </ng-container>
</form>
